<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage" id="tit01">
<a id="page05"></a>
<h2 class="titlePageAuthorcenter">Edna Buchanan</h2>
<h2 class="titlePageTitlecenter">The Ice Maiden</h2>
<p class="colophoncenter"><img alt="image" src="Images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// icemaidenthe_tit01.vue?025513fe